// Como restaurar cada tipo de item da lixeira (0.65). Importado uma vez ao abrir o app.
import { registrarRestauro } from './lixeira';
import { getDoc, setDoc } from '../store/store';
import { salvarVarios } from '../store/modulos';
import type { Box, GcalApagar, ModId, Reg, Task } from '../store/types';
import { cancelarApagarGcal } from '../store/planner';

// fichas das abas (com tudo o que estava dentro)
registrarRestauro('reg', (regs: Reg[], extra: { mod: ModId }) => { if (extra?.mod && Array.isArray(regs)) salvarVarios(extra.mod, regs); });
/** Põe o item de volta na posição em que estava (0.67); sem posição, no fim. */
function naPosicao<T>(l: T[], x: T, pos?: number): T[] {
  if (pos === undefined || pos < 0 || pos > l.length) return [...l, x];
  return [...l.slice(0, pos), x, ...l.slice(pos)];
}
// tarefa do My Planner
// (texto 05 C): a exclusão que estava na fila da agenda do Google é cancelada. Se o celular já apagou o evento lá,
// a tarefa volta sem o vínculo (senão a sincronização a tiraria de novo); com o envio ligado, ela vai de novo para a agenda.
registrarRestauro('tarefa', (tk: Task, extra?: { gcal?: GcalApagar[] }) => {
  const feitas = cancelarApagarGcal(extra?.gcal);
  const volta: Task = feitas.length && tk.gcal ? { ...tk, gcal: undefined } : tk;
  setDoc('planner', d => ({ tasks: d.tasks.some(x => x.id === tk.id) ? d.tasks : [...d.tasks, volta] }));
});
// "Esta e todas as futuras" (texto 05 C): a tarefa volta a ter a data de fim de antes
registrarRestauro('tarefa-fim', (x: { id: string; end: string | null }, extra?: { gcal?: GcalApagar[] }) => {
  if (!x?.id) return;
  cancelarApagarGcal(extra?.gcal);
  setDoc('planner', d => ({ tasks: d.tasks.map(tk => (tk.id === x.id ? { ...tk, end: x.end, updatedAt: new Date().toISOString() } : tk)) }));
});
// caixa de anotações
registrarRestauro('caixa', (b: Box, extra?: { pos?: number }) => setDoc('anotacoes', d => ({ ...d, boxes: d.boxes.some(x => x.id === b.id) ? d.boxes : naPosicao(d.boxes, b, extra?.pos ?? 0) })));
// item da lista rápida
registrarRestauro('rapida', (i: any, extra?: { pos?: number }) => setDoc('anotacoes', d => ({ ...d, quick: d.quick.some(x => x.id === i.id) ? d.quick : naPosicao(d.quick, i, extra?.pos) })));
// genérico: um item numa lista de um documento (garantias, documentos, cômodos, tarefas da casa, Bem-Estar, Finanças...)
registrarRestauro('lista', (item: any, extra: { doc: string; campo: string; pos?: number }) => {
  if (!extra?.doc || !extra.campo) return;
  setDoc(extra.doc as any, (d: any) => {
    const l: any[] = d?.[extra.campo] ?? [];
    return l.some(x => x.id === item.id) ? d : { ...d, [extra.campo]: naPosicao(l, item, extra.pos) };
  });
});
// Estudos: fichário, matéria ou página
registrarRestauro('estudos', (x: any, extra: { tipo: 'fichario' | 'materia' | 'pagina'; fid?: string; mid?: string; pos?: number }) => {
  setDoc('estudos', d => {
    if (extra.tipo === 'fichario') return d.ficharios.some(f => f.id === x.id) ? d : { ...d, ficharios: naPosicao(d.ficharios, x, extra.pos) };
    return { ...d, ficharios: d.ficharios.map(f => f.id !== extra.fid ? f : extra.tipo === 'materia'
      ? (f.materias.some(m => m.id === x.id) ? f : { ...f, materias: naPosicao(f.materias, x, extra.pos) })
      : { ...f, materias: f.materias.map(m => m.id !== extra.mid || m.paginas.some(p => p.id === x.id) ? m : { ...m, paginas: naPosicao(m.paginas, x, extra.pos) }) }) };
  });
});
// Finanças: item com o que vai junto (cartão + compras + faturas pagas; conta + pagamentos lançados)
registrarRestauro('financas', (x: Record<string, any[]>) => setDoc('financas', (d: any) => {
  const n = { ...d };
  for (const [campo, l] of Object.entries(x ?? {})) {
    const atual: any[] = d?.[campo] ?? [];
    const novos = (l ?? []).filter(i => (i && typeof i === 'object' ? !atual.some(a => a?.id === i.id) : !atual.includes(i)));
    n[campo] = [...atual, ...novos];
  }
  return n;
}));
void getDoc;
import { registrarRelatorio } from './relatorios';
// relatório gerado (só o atalho: Drive, OneDrive ou pasta escolhida) volta para o histórico da aba
registrarRestauro('relatorio', (r: any) => { if (r?.nome) registrarRelatorio({ nome: r.nome, mime: r.mime, tamanho: r.tamanho ?? 0, uri: r.uri, url: r.url, doApp: r.doApp, aba: r.aba }); });
// Scanner PDF: a pasta volta e os documentos que estavam nela (e continuam sem pasta) voltam para ela
registrarRestauro('scanner-pasta', (p: { id: string; nome: string }, extra: { docs?: string[] }) => setDoc('scanner', d => ({ ...d,
  pastas: (d.pastas ?? []).some(x => x.id === p.id) ? d.pastas : [...(d.pastas ?? []), p],
  docs: (d.docs ?? []).map(x => (extra?.docs?.includes(x.id) && !x.pasta ? { ...x, pasta: p.id } : x)) })));
// 0.67 (texto 05 F): dias tirados de uma tarefa que se repete ("Limpar a agenda") voltam a aparecer
registrarRestauro('ocorrencias', (x: { id: string; dias: string[] }, extra?: { gcal?: GcalApagar[] }) => {
  if (!x?.id || !Array.isArray(x.dias)) return;
  cancelarApagarGcal(extra?.gcal);
  setDoc('planner', d => ({ tasks: d.tasks.map(tk => (tk.id === x.id ? { ...tk, skip: tk.skip.filter(s => !x.dias.includes(s)), updatedAt: new Date().toISOString() } : tk)) }));
});
// Monitor de publicações (texto 05 C): o perfil volta para o mesmo lugar, com os resultados dele
import { voltarPerfil } from '../store/monitor';
registrarRestauro('monitor-perfil', (x: any, extra?: { pos?: number }) => voltarPerfil(x, extra?.pos));
